import { useState } from 'react';
import { SearchInput, INPUT_SIZES } from 'cdk-radial';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { AllTags } from './AllTags';
import { Tag } from './Tag';

export const TagCloud = styled(({ className, list }) => {
  const [search, setSearch] = useState('');

  // Use a Set to dedpue tags
  const tagSet = new Set();
  list.forEach((example) => example.tags.forEach((tag) => tagSet.add(tag.toUpperCase())));
  // Make an array out of the Set
  const initTags = [...tagSet].sort();
  const allTags = initTags.filter((tag) => tag.toLowerCase().includes(search.toLowerCase()));

  // Get the path and search from the URL
  const [searchParams] = useSearchParams();
  const searchTags = searchParams.get('tags');

  // Put the tags from the queryString into an array
  const activeTags = searchTags !== null ? searchTags?.split(',') : [];

  return (
    <div className={className}>
      <h3>All Tags</h3>
      <SearchInput
        className="searchInput"
        size={INPUT_SIZES.SMALL}
        isAlwaysExpanded
        name="TagSearch"
        value={search}
        onChange={setSearch}
        id="searchInput"
        disableBrowserAutocomplete
      />
      <AllTags className="AllTags">
        {allTags.map((tag, index) => {
          return <Tag key={`${index} ${tag}`} active={activeTags?.includes(tag.toLowerCase())} tag={tag} />;
        })}
      </AllTags>
    </div>
  );
})`
  h3 {
    margin: 32px 0 16px;
  }
  ${AllTags} {
    margin-top: 16px;
  }
  .searchInput {
    margin: 0 0 0 6px;
    width: calc(100% - 12px);
  }
`;
